var exports = {
  "kL": "container__GR-5xw",
  "r9": "disabled__viG5t4",
  "PG": "contents__9pL_Vq",
  "nf": "link__Hk5Nsr",
  "pW": "leadingVisual__jwUk-f",
  "nW": "blockIcon__Ro24F7",
  "iE": "leadingIcon__UCrBq2",
  "DD": "title__SMQnPj",
  "h_": "description__-nN65w",
  "jk": "blockControl__42J8dJ",
  "Wq": "supplementalControl__U57q7A",
  "LX": "trailingVisual__-sTMS3",
  "it": "itemLink__tw3yQv",
  "qr": "footer__Re2Big",
};

module.exports = exports;
